
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const STRIPE_PUBLISHABLE_KEY = new InjectionToken<Promise<string>>(
	'Stripe Publishable Key'
);
export const US_STRIPE_PUBLISHABLE_KEY = new InjectionToken<Promise<string>>(
	'US Stripe Publishable Key'
);
export const STRIPE_OPTIONS = new InjectionToken<stripe.elements.ElementsCreateOptions>('Stripe Options');
export const STRIPE_STYLE_OPTIONS = new InjectionToken<stripe.elements.ElementsOptions>('Stripe Style Options');

export const defaultStripeOptions: stripe.elements.ElementsCreateOptions = {
	fonts: [{
		cssSrc: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700'
	}]
};
export const defaultStripeStyles: stripe.elements.ElementsOptions = {
	classes: {
		base: 'stripeInput',
		focus: 'stripeInput--focus',
		invalid: 'stripeInput--invalid',
	},
	hidePostalCode: true,
	style: {
		base: {
			// Add your base input styles here. For example:
			fontSize: '14px',
			lineHeight: '15px',
			fontFamily: 'Roboto',
			color: 'rgba(0, 0, 0, 0.87)'
		},
	}
};

export class StripeCard {
	card: stripe.elements.Element;
	onChange: Observable<stripe.elements.ElementChangeResponse>;
	createToken: (options?: stripe.TokenOptions) => Promise<stripe.TokenResponse>;
}
